(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/hooks/use-marketplace.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/hooks/use-marketplace.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  notificationsMarketplaceService
} = svs.myProfile.react.pages.notifications;

const useMarketplace = (setPlayerMarketplaceData, setShouldShowApiError) => {
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  useEffect(() => {
    const getData = async () => {
      try {
        svs.myProfile.logger.debug('Fetch Customers Settings data from backend...');
        const {
          notificationSettings,
          error
        } = await notificationsMarketplaceService.getCustomersMarketplaceDataAsync();
        if (error) {
          svs.myProfile.logger.error('Fetch Customers Marketplace data from backend... error:', error);
          setShouldShowApiError(true);
        } else {
          svs.myProfile.logger.debug('Fetch Customers Marketplace data from backend... success');
          setPlayerMarketplaceData(notificationSettings);
        }
      } catch (error) {
        svs.myProfile.logger.error('CommunicationSettings: catch: Fetch Customers Marketplace data error: ', error);
        setShouldShowApiError(true);
      }
    };
    if (isPlayerLoggedIn) {
      getData();
    }
  }, []);
};
useMarketplace.propTypes = {
  setPlayerMarketplaceData: PropTypes.func.isRequired,
  setShouldShowApiError: PropTypes.func.isRequired
};
svs.myProfile.react.pages.notifications.hooks.useMarketplace = useMarketplace;

 })(window);